<div *ngIf="dSS.dienststelle && dSS.modusErweitert" class="ride-group">
  <ion-row>
    <ion-col>
      <h3>Rad</h3>
    </ion-col>
  </ion-row>
</div>
<ion-row class="pt-2">
  <ion-col class="py-0 position-relative">
    <span
      *ngIf="!dSS.kaufpreisTouched && !!dSS.kaufpreis"
      class="rd-example-badge"
      >Beispielwert</span
    >
    <ion-item
      lines="inset"
      id="rd-field-kaufpreis"
      class="required-field"
      [class.is-empty]="!dSS.kaufpreis"
      [class.is-untouched]="!dSS.kaufpreisTouched && !!dSS.kaufpreis"
      [class.is-error]="dSS.showRequiredErrors && (!dSS.kaufpreis || !dSS.kaufpreisTouched)"
    >
      <ion-input
        label="Bruttokaufpreis inkl. Zubehör"
        labelPlacement="floating"
        type="number"
        pattern="\d+(\.\d{1,2})?(,\d{1,2})?"
        [(ngModel)]="dSS.kaufpreis"
        (ionChange)="onKaufpreisInput()"
        (ionFocus)="dSS.kaufpreisTouched = true"
        (ionInput)="onKaufpreisInput()"
        placeholder="Angabe erforderlich!"
        [max]="dSS.getMaxPreis()"
        [min]="dSS.dienststelle?.minPreis"
        [required]="true"
        ><ion-icon
          *ngIf="!!dSS.kaufpreis"
          name="logo-euro"
          class="eur_logo__position"
        ></ion-icon
      ></ion-input>
    </ion-item>
    <ion-text color="danger" *ngIf="dSS.kaufpreis > dSS.getMaxPreis()">
      <p class="ion-padding-start ion-padding-top">
        Der Höchstpreis für das Dienstrad-Leasing liegt bei
        {{ dSS.getMaxPreis() }} €.
      </p>
    </ion-text>
        <ion-text color="danger" *ngIf="dSS.kaufpreis < dSS.dienststelle?.minPreis">
      <p class="ion-padding-start ion-padding-top">
        Der Mindestpreis für das Dienstrad-Leasing liegt bei
        {{ dSS.dienststelle?.minPreis }} €.
      </p>
    </ion-text>
  </ion-col>
</ion-row>

<ng-container *ngIf="dSS.modusErweitert">
  <ion-row>
    <ion-col class="py-0 position-relative">
      <ion-item
        lines="inset"
        id="rd-field-uvp"
        class="required-field"
        [class.is-empty]="!dSS.bruttoKaufUVP"
        [class.is-error]="dSS.showRequiredErrors && !dSS.bruttoKaufUVP"
      >
        <ion-label position="stacked">
          <div class="info-label">
            <span
              >UVP/Bruttolistenpreis des Herstellers inkl. Zubehör<span
                *ngIf="!dSS.bruttoKaufUVP"
                class="rd-required-mark"
                aria-hidden="true"
              ></span
            ></span>
            <ion-icon
              class="info-icon"
              name="information-circle-outline"
              (click)="dSS.toggleInfo('C')"
            ></ion-icon>
          </div>
        </ion-label>
        <ion-input
          type="number"
          pattern="\d+(\.\d{1,2})?(,\d{1,2})?"
          [(ngModel)]="dSS.bruttoKaufUVP"
          (ionChange)="onUVPInput()"
          (ionInput)="onUVPInput()"
          placeholder="Angabe erforderlich!"
          [required]="true"
        ></ion-input>
      </ion-item>
      <div *ngIf="dSS.currInfo === 'C'" class="info-box">
        <p class="info-text">
          Die unverbindliche Preisempfehlung (UVP) versteht sich inklusive
          Mehrwertsteuer und Zubehör. Sie dient als Grundlage zur Berechnung des zu
          versteuernden geldwerten Vorteils.
        </p>
      </div>
      <ion-text
        color="danger"
        *ngIf="dSS.bruttoKaufUVP > dSS.getMaxPreis()"
      >
        <p class="ion-padding-start ion-padding-top">
          Der Höchstpreis für das Dienstrad-Leasing liegt bei
          {{ dSS.getMaxPreis() }} €.
        </p>
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-list>
        <ion-item lines="inset">
          <ion-select
            label="Radtyp"
            labelPlacement="floating"
            [(ngModel)]="dSS.bikeCategory"
            (ionChange)="update($event)"
          >
            <ion-select-option
              *ngFor="let option of getBikeCategoryOptions()"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
</ng-container>
